module.exports = __webpack_public_path__ + "img/SD.a210feca.png";